export default __webpack_public_path__ + "static/media/sign-in-ai.66badd6d.svg";